export default __webpack_public_path__ + "../staticImages/einschenk1-260.png";